import { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Hammer,
  Mail,
  Phone,
  MapPin,
  CircleCheck,
  Instagram,
  Facebook,
  Twitter,
  ChevronDown,
  
} from 'lucide-react';
import { FaXTwitter, FaTwitter } from "react-icons/fa6";


import HPlogo from '../../assets/HPlogo.png';
import { toast } from 'sonner';
import { subscribeUserApi } from '../../global-api/user.api';

export default function Footer() {
  const [isSubscribed, setIsSubscribed] = useState(false);
  const subscribeRef = useRef(null);
  const validEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleSubscribe = async () => {
    const email = subscribeRef.current.value;
    if (!validEmail.test(email)) {
      toast.error('Please enter valid email');
      return;
    }
    if (email.trim()) {
      try {
        await subscribeUserApi(email);
        setIsSubscribed(true);
        toast.success('Subscribed Successfully');
      } catch (err) {
        setIsSubscribed(false);
        console.log(err);
        if (err.status === 409) {
          toast.error('Already Subscribed User');
        } else {
          toast.error('Please try again!');
        }
      }
    }
  };

  const [openSection, setOpenSection] = useState(null);

  const toggleSection = (title) => {
    if (window.innerWidth >= 1024) return;
    setOpenSection(openSection === title ? null : title);
  };

  const footerData = [
    {
      title: 'For Clients',
      links: [
        ['Browse Artisans', '/artisans'],
        ['Categories', '/categories'],
        ['How It Works', '/how-it-works'],
        ['Pricing', '/pricing'],
      ],
    },
    {
      title: 'For Artisans',
      links: [
        ['Become an Artisan', ''],
        ['Resources', '/resources'],
        ['Community', '/community'],
        ['FAQ', '/faq'],
      ],
    },
    {
      title: 'Company',
      links: [
        ['About Us', '/about'],
        ['Support or Contact', '/support'],
        ['Terms', '/terms'],
        ['Privacy & Policy', '/privacy'],
      ],
    },
  ];

  return (
    <footer className="bg-timber-300 text-white">
      <div className="max-w-7xl mx-auto px-4 py-14 sm:py-16">
        {/* Top Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-0 lg:gap-12 text-left">
          {/* Brand */}
          <div className="lg:col-span-2 mb-10 lg:mb-0">
            <Link to="/" className="flex items-center group relative">
              <img 
                src={HPlogo} 
                alt="Handpreneur" 
                className="h-10 w-auto object-contain transition-transform duration-300 group-hover:scale-105"
              />
            </Link>

            <p className="text-gray-800 mt-4 max-w-md text-sm sm:text-base">
              The leading platform connecting talented artisans with clients
              worldwide.
            </p>

            <div className="space-y-2 mt-6 text-sm">
              <div className="flex items-center gap-3 text-gray-800">
                <Mail size={16} /> support@Handpreneur.com
              </div>
              <div className="flex items-center gap-3 text-gray-800">
                <Phone size={16} /> +1 (587) 693-1737
              </div>
              <div className="flex items-center gap-3 text-gray-800">
                <MapPin size={16} /> Red Deer, Alberta, Canada
              </div>
            </div>
          </div>

          {/* Links Sections with Mobile Accordion */}
          {footerData.map(({ title, links }) => (
            <div
              key={title}
              className="col-span-1 border-b border-gray-200/50 lg:border-none last:border-b-0 lg:last:border-none"
            >
              <button
                onClick={() => toggleSection(title)}
                className="w-full flex items-center justify-between py-4 lg:py-0 lg:mb-6 group"
              >
                <h3 className="font-bold text-base sm:text-lg text-gray-800 lg:group-hover:text-rose-600 transition-colors">
                  {title}
                </h3>
                <ChevronDown
                  className={`w-5 h-5 text-gray-400 transition-transform duration-300 lg:hidden 
                ${openSection === title ? 'rotate-180' : ''}`}
                />
              </button>

              <div
                className={`overflow-hidden transition-all duration-300 lg:max-h-none 
            ${openSection === title ? 'max-h-60 pb-6' : 'max-h-0 lg:block'}`}
              >
                <ul className="space-y-3 text-sm">
                  {links.map(([label, to]) => (
                    <li key={label}>
                      <FooterLink to={to}>{label}</FooterLink>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* Newsletter */}
        <div className="mt-14 pt-10 border-t border-gray-800">
          <div className="max-w-xl mx-auto text-center">
            <h3 className="text-xl sm:text-2xl font-bold mb-3 text-gray-800">
              Stay Updated
            </h3>
            <p className="text-gray-800 text-sm sm:text-base mb-6">
              Subscribe to our newsletter for updates
            </p>

            <div className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
              <input
                ref={subscribeRef}
                type="email"
                placeholder="Enter your email"
                className="flex-1 px-4 py-3 bg-gray-200 border border-gray-100 rounded-xl text-gray-800 focus:outline-none focus:ring-2 focus:ring-rose-500 transition-all"
              />

              <button
                onClick={handleSubscribe}
                className={`px-8 py-3 rounded-xl font-bold whitespace-nowrap transition-all shadow-md
              ${
                isSubscribed
                  ? 'bg-emerald-500 text-white'
                  : 'bg-gradient-to-r from-rose-500 to-pink-500 text-white hover:shadow-lg hover:shadow-rose-500/20'
              }
            `}
              >
                {isSubscribed ? (
                  <span className="flex items-center justify-center gap-2">
                    Subscribed <CircleCheck size={18} />
                  </span>
                ) : (
                  'Subscribe'
                )}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
    <div className="border-t border-gray-200/50">
  <div className="max-w-7xl mx-auto px-4 py-8 pb-28 md:pb-8">

    {/* Top Footer */}
    <div className="grid grid-cols-1 md:grid-cols-3 gap-10 items-center">

      {/* Left */}
     {/* Left */}
<div className="flex flex-col items-center md:items-start gap-1">

  <span className="text-gray-800 font-bold text-base">
    © 2025 Handpreneur
  </span>

  <p className="text-gray-500 text-[11px] uppercase tracking-[0.25em] font-semibold">
    Connecting Craft & Commerce
  </p>

  <a
    href="https://xun.dev"
    target="_blank"
    rel="noopener noreferrer"
    className="mt-2 text-[10px] text-gray-400 hover:text-gray-600 transition-colors duration-300"
  >
    Website by <span className="font-semibold">Xun Innovation</span>
  </a>

</div>

      {/* Center */}
      <div className="flex justify-center gap-6 text-gray-600">

        <a
          href="https://www.facebook.com/handpreneurinc"
          className="hover:text-rose-600 transition-all duration-300 hover:-translate-y-1"
        target='_blank'
        >
          <Facebook size={22} />
        </a>

        <a
          href="https://x.com/HandpreneurInc"
          className="hover:text-rose-600 transition-all duration-300 hover:-translate-y-1"
        target='_blank'
        >
         
       <FaXTwitter  size={22}/>
          
        </a>

        <a
          href="https://www.instagram.com/handpreneurinc/"
          className="hover:text-rose-600 transition-all duration-300 hover:-translate-y-1"
        target='_blank'
        >
          <Instagram size={22} />
        </a>

      </div>

      {/* Right */}
      <div className="flex flex-col items-center md:items-end gap-2">

        <span className="text-[10px] uppercase tracking-widest text-gray-500 font-bold">
          Secure Payments
        </span>

        <div className="flex gap-3">

          <div className="bg-white px-3 py-1.5 rounded-lg border border-gray-200 shadow-sm min-w-[55px] flex justify-center">
            <span className="text-[10px] font-black italic text-blue-800">
              VISA
            </span>
          </div>

          <div className="bg-white px-3 py-1.5 rounded-lg border border-gray-200 shadow-sm min-w-[55px] flex justify-center">
            <span className="text-[10px] font-black italic text-red-600">
              MC
            </span>
          </div>

        </div>

      </div>

    </div>

    {/* Bottom Branding */}
   

  </div>
</div>
    </footer>
  );
}

function FooterLink({ to, children }) {
  return (
    <Link
      to={to}
      className="text-gray-800 hover:text-gray-500 transition-colors"
    >
      {children}
    </Link>
  );
}
